import React from "react";
import formatMoney from "../MoneyFormatter";
const AmountDisplay = ({ amount, displayCurrency = true }) => {
  if (isNaN(amount)) {
    return <span>{`${formatMoney(0)}`}</span>;
  } else return <span>{`${formatMoney(amount)}`}</span>;
};

export default AmountDisplay;
